(function () {
  class WinController {
    constructor() {
      this._batcher = undefined;
      this._winlineAnimator = undefined;
      this._symbolAnimator = undefined;
      this._active = false;
      this._skipped = false;
    }

    initialise(json) {
      this._batcher = resourceManager.getSharedPlugin(json.batcher_normal);
      this._symbolAnimator = json.symbolAnimator ? resourceManager.get(json.symbolAnimator) : undefined;
      this._winlineAnimator = json.winlineAnimator ? resourceManager.getSharedPlugin(json.winlineAnimator) : undefined;
    }

    startAnimations(winData, celebrationThreshold, slotMachine, completeCallback) {
      let self = this;
      self._active = true;
      let canCelebrate = winData.totalLineWinnings > celebrationThreshold;
      let sequenceData = this._batcher.batch(winData, celebrationThreshold);
      this._skipped = false;

      let currentSequence = 0;
      let playNextSequence = function (i) {
        if (canCelebrate) {
          let bestSymbolWin = -1;
          if (currentSequence === 0) {
            for (let j = 0; j < sequenceData[i].length; ++j) {
              if (sequenceData[i][j].winId > bestSymbolWin) {
                bestSymbolWin = sequenceData[i][j].winId;
              }
            }
          } else {
            bestSymbolWin = 0;
          }

          const winnings = winData.totalLineWinnings;
          const stake = gameController.getCurrentModeStake();
          if (winnings <= stake) {
            soundManager.play("lowerThanStakeWin");
          } else if (winnings < stake * 5) {
            soundManager.play("smallWin");
          } else if (winnings < stake * 10) {
            soundManager.play("mediumLowWin");
          } else if (winnings < stake * 20) {
            soundManager.play("mediumHighWin");
          } else {
            soundManager.play("highWin");
          }
        }

        let linesToPlay = [];

        for (let j = 0; j < sequenceData[i].length; ++j) {
          linesToPlay.push(sequenceData[i][j].winline);
        }

        let uniqueArray = linesToPlay.filter(function (item, pos) {
          return linesToPlay.indexOf(item) == pos;
        });

        let winlines = [];
        for (let j = 0; j < uniqueArray.length; ++j) {
          winlines.push(winData.winningLines[uniqueArray[j]]);
        }

        if (self._symbolAnimator) {
          self._symbolAnimator.animateSymbols(
            sequenceData[i],
            slotMachine,
            canCelebrate,
            false,
            function () {
              ++currentSequence;
              if (currentSequence >= sequenceData.length || self._skipped) {
                self._active = false;
                completeCallback();
              } else {
                if (self._skipped) {
                  self._active = false;
                  completeCallback();
                } else {
                  playNextSequence(currentSequence);
                }
              }
            },
            function () {}
          );
        }
      };
      playNextSequence(currentSequence);
    }

    isActive() {
      return this._active;
    }

    skipAnimations() {
      if (this.isActive()) {
        this._skipped = true;
        this._symbolAnimator.skip();
        if (this._winlineAnimator) this._winlineAnimator.skipAnimation();
      }
    }
  }

  let createWinController = function () {
    return new WinController();
  };

  resourceManager.registerController("WinControllerAllAtOnce", createWinController);
})();
